import type { ButtonHTMLAttributes } from "react";
import { buttonClass } from "@/components/buttonStyles";

// The primary submit button, on the one button style (BRK-S264). It shows a
// pending label and disables itself while a request is in flight, so a broker
// can't double-submit a login or a save. The sign-in card's forms run it the
// card's width (`full`); an in-page form's sits at its content's width.
interface SubmitButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  pending?: boolean;
  pendingLabel?: string;
  full?: boolean;
  children: React.ReactNode;
}

export function SubmitButton({
  pending = false,
  pendingLabel = "Working…",
  full = false,
  children,
  disabled,
  ...props
}: SubmitButtonProps) {
  return (
    <button
      type="submit"
      disabled={disabled ?? pending}
      // A form stacks its fields in a column, which would stretch the button
      // across it; at its content's width it starts the row instead.
      className={`${buttonClass({ full })} ${full ? "" : "self-start"}`}
      {...props}
    >
      {pending ? pendingLabel : children}
    </button>
  );
}
